import React, { useEffect, useState } from 'react'
import { Input } from 'rsuite'
import { ReactComponent as Edit } from '../../../assets/svgs/edit.svg'
import { ReactComponent as EditSave } from '../../../assets/svgs/edit-save.svg'
import { ReactComponent as EditDiscard } from '../../../assets/svgs/edit-discard.svg'
import './editable-cell.scss'

interface IEditableCell {
  // eslint-disable-next-line
  rowData: any
  dataKey: string
  initialValue?: string
  required?: boolean
  // eslint-disable-next-line
  onChange: (rowData: any, dataKey: string, tempValue: string) => void
}
export const EditableCell = ({
  rowData,
  dataKey,
  onChange,
  initialValue,
  required,
}: IEditableCell) => {
  const [editable, setEditable] = useState(false)
  const [value, setValue] = useState(rowData[dataKey])
  const [tempValue, setTempValue] = useState(rowData[dataKey])

  const handleSave = () => {
    setEditable(false)
    onChange?.(rowData?.recordSystemId, dataKey, tempValue)
    setValue(tempValue)
  }

  const handleCancel = () => {
    setEditable(false)
    setTempValue(value)
  }

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue)
      setTempValue(initialValue)
    } else {
      setValue(rowData[dataKey])
      setTempValue(rowData[dataKey])
    }
  }, [initialValue, onChange])

  return (
    <div className="editable-cell-wrapper">
      {editable ? (
        <>
          <Input
            size="sm"
            value={tempValue}
            onChange={setTempValue}
            style={{ flex: 1 }}
            autoFocus
          />
          <EditSave
            onClick={handleSave}
            className={`${(rowData[dataKey] || initialValue) === tempValue || (required && tempValue.trim() === '') ? 'disabled' : ''}`}
          />
          <EditDiscard onClick={handleCancel} />
        </>
      ) : (
        <>
          {initialValue ? (
            <Input
              size="sm"
              disabled={!editable}
              value={value}
              style={{
                flex: 1,
                border: 'none',
                background: 'inherit',
                textOverflow: 'ellipsis',
              }}
            />
          ) : (
            <span className="editable-cell-span">{value || '-'}</span>
          )}
          <Edit onClick={() => setEditable(true)} />
        </>
      )}
    </div>
  )
}

export default EditableCell
